import CustomerAppointmentsTable from "./CustomerAppointmentsTable";
export default CustomerAppointmentsTable;
